import React from "react";
import Linkify from 'linkify-react';

export default class PreviewLink extends React.Component {
   constructor(props) {
      super(props)
   }
   render() {
      const { content, itemName, url, imgUrl, site } = this.props;

      return (
         <div className="preview-link">
            <div className="content">
               {content}
            </div>
            <a href={url} target='_blank'>
               {imgUrl && <div className="image"><img src={imgUrl} alt={itemName} /></div>}
               <div className="site">{site}</div>
               <div className="description">{itemName}</div>
            </a>
         </div>
      )
   }
}